import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import S from './RequiredStar.styl.js';

function RequiredStar(props) {
    const { className, inline, ...rest } = props;
    const classes = cn(S.root, className, inline && S.inline);
    return jsx(Icon, { ...rest, type: "requiredStar", className: classes });
}

export { RequiredStar };
